// src/api/workspacesApi.ts

import { baseApi } from './baseApi';
import type {
  UserWorkspaceSummary,
  CreateWorkspaceRequest,
  CreateWorkspaceResponse,
  SwitchWorkspaceResponse,
  WorkspaceCreditsResponse,
} from '../types/api';

export const workspacesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWorkspaces: builder.query<UserWorkspaceSummary[], void>({
      query: () => '/workspaces',
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ workspace }) => ({
                type: 'Workspace' as const,
                id: workspace.id,
              })),
              { type: 'Workspace', id: 'LIST' },
            ]
          : [{ type: 'Workspace', id: 'LIST' }],
    }),

    createWorkspace: builder.mutation<CreateWorkspaceResponse, CreateWorkspaceRequest>({
      query: (body) => ({
        url: '/workspaces',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Workspace', id: 'LIST' }],
    }),

    switchWorkspace: builder.mutation<SwitchWorkspaceResponse, string>({
      query: (workspaceId) => ({
        url: `/workspaces/${workspaceId}/switch`,
        method: 'POST',
      }),
      invalidatesTags: [
        { type: 'Workspace', id: 'LIST' },
        { type: 'Menu', id: 'LIST' },
        { type: 'Conversation', id: 'LIST' },
      ],
    }),

    getWorkspaceCredits: builder.query<WorkspaceCreditsResponse, string>({
      query: (workspaceId) => `/workspaces/${workspaceId}/credits`,
      providesTags: (result, error, workspaceId) => [
        { type: 'Credits', id: workspaceId },
      ],
    }),
  }),
});

export const {
  useGetWorkspacesQuery,
  useCreateWorkspaceMutation,
  useSwitchWorkspaceMutation,
  useGetWorkspaceCreditsQuery,
} = workspacesApi;
